import { RouteWithHeaderBackButton } from 'core';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { Home } from '../../pages/home/Home';
import { Buy } from '../../pages/home/HowToGiveback/Buy';
import { Dine } from '../../pages/home/HowToGiveback/Dine';
import { ShopOnline } from '../../pages/home/HowToGiveback/ShopOnline';
import { YourPersonalizedStart } from '../../pages/home/YourPersonalizedStart/YourPersonalizedStart';

const HomeBackButtonProvider = () => {
  return (
    <RouteWithHeaderBackButton>
      <Outlet />
    </RouteWithHeaderBackButton>
  );
};

const HomeRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route element={<HomeBackButtonProvider />}>
          <Route path="online" element={<ShopOnline />} />
          <Route path="dine" element={<Dine />} />
          <Route path="buy" element={<Buy />} />
          {/* Redirecting to /home because we are deprecating How to Giveback --> "<Give />", and eventually the whole section */}
          <Route path="give" element={<Navigate to=".." replace />} />
        </Route>
      </Routes>
      <Routes>
        <Route path="/onboarding/your-personalized-start" element={<YourPersonalizedStart />} />
      </Routes>
    </>
  );
};

export { HomeRoutes };
